/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ReprocessGradePersonOnlyBatchViewModel } from "../types/ReprocessGradePersonOnlyBatchViewModel.ts";

export const reprocessGradePersonOnlyBatchViewModelSchema = z.object({
  classroomDisciplineIds: z
    .array(z.number().int())
    .describe(
      "Lista de IDs das disciplinas nas salas de aula para as quais as notas devem ser reprocessadas em lote. Obrigatório.",
    )
    .nullish(),
  personId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da pessoa (aluno) cujas notas devem ser reprocessadas em lote. Obrigatório.",
      ),
  ),
}) as unknown as ToZod<ReprocessGradePersonOnlyBatchViewModel>;
